<main class="container">
  <div class="row">
    <div class="col-sm-6 col-sm-offset-3">
      <!-- @if (ViewBag.Error != null)
      {
          <div class="alert alert-danger">@Html.Raw(ViewBag.Error)</div>
      } -->

      <div class="row" *ngIf="isshowLoginMessage">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="alert alert-danger">
            {{showLoginMessage}} Please
            <a class="logincolor" href="/auth/login"> LOGIN</a>
          </div>
        </div>
      </div>
      <div class="panel panel-default" id="layoutPanel">
        <div class="panel-heading" id="layoutPanelHeading">
          <strong>Create Password</strong>
        </div>
        <div class="panel-body" id="layoutPanelBody">
          <form role="form" #form="ngForm" (ngSubmit)="save(form)">
            <fieldset>
              <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding-left: 8%; padding-right: 8%;">
                      <div class="form-group">
                          <div class="input-group" style="width:100%">
                              <span class="input-group-addon" style="width: 160px; text-align: left">
                                  <i class="fa fa-envelope"></i>
                                  <span class="control-label" style="color: black; margin-left: 10px;">Email</span>
                              </span>
                              <input style="background: #f5f5f5b0; " type="text"
                                     name="username"
                                     id="username"
                                     [(ngModel)]="username"
                                     class="form-control"
                                     disabled/>
                          </div>
                      </div>
                      <div class="form-group">
                          <div class="input-group" style="width:100%">
                              <span class="input-group-addon" style="width: 160px; text-align: left">
                                  <i class="fa fa-lock fa-lg"></i>
                                  <span class="control-label" style="color: black; margin-left: 10px;">Password</span>
                              </span>
                              <input type="password"
                                     name="password"
                                     id="password"
                                     [(ngModel)]="password"
                                     onkeypress="return (((event.charCode >= 48) && (event.charCode <= 57)) || ((event.charCode >= 65) && (event.charCode <= 90)) || ((event.charCode >= 97) && (event.charCode <= 122)) || ((event.charCode >= 33) && (event.charCode <= 44)) || ((event.charCode >= 46) && (event.charCode <= 47))  || ((event.charCode >= 58) && (event.charCode <= 64)) || (event.charCode == 91) || ((event.charCode >= 93) && (event.charCode <= 95)) || (event.charCode == 123) || (event.charCode == 125) )"
                                     class="form-control"
                                     cgPasswordToggle
                                     required>
                          </div>
                      </div>
                      <div class="form-group" style="margin-bottom: 5px;">
                          <div class="input-group" style="width:100%">
                              <span class="input-group-addon" style="width: 160px; text-align: left">
                                  <i class="fa fa-lock fa-lg"></i>
                                  <span class="control-label" style="color: black; margin-left: 10px;">Confirm Password</span>
                              </span>
                              <input type="password"
                                     name="repeatPassword"
                                     id="repeatPassword"
                                     class="form-control"
                                     [(ngModel)]="confirmpassword"
                                     cgPasswordToggle
                                     required />
                          </div>
                      </div>
                      <div class="password-error" *ngIf="!isPasswordValid">
                          <i class="fa fa-exclamation-circle"></i>
                          <span>{{errorMessage}}</span>
                      </div>
                      <div><span class="control-label" style="font-size: 11px; color: #494444;">Password must be between 8 and 15 characters long,</span></div>
                      <div><span class="control-label" style="font-size: 11px; color: #494444;">Include at least one number, and contain at least one lowercase letter.</span></div>
                      <div class="form-group" style="margin-top:5px">
                          <input type="submit" id="btnCreatePassword" class="btn btn-lg btn-primary btn-block" value="Create Password">
                      </div>
                  </div>
              </div>
            </fieldset>

          </form>
        </div>
      </div>
    </div>
  </div>

</main>


